// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N24BjNiJXIEuYGmZapwN{flex:1;justify-content:center;align-items:center;display:flex}.HGhC8dX30W4lB8x9iwyl{text-align:center;max-width:380px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyPage": `N24BjNiJXIEuYGmZapwN`,
	"emptyWrap": `HGhC8dX30W4lB8x9iwyl`
};
export default ___CSS_LOADER_EXPORT___;
